import { createContext } from "react";

export const TeachersContext = createContext();
